import firebase from "firebase/app";
import "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Firebase初期化処理
if (firebase.apps.length === 0) {
  (async () => {
    await firebase.initializeApp(firebaseConfig);
    firebase.auth().languageCode = 'ja';

    // 開発環境ではエミュレータを使用
    if (process.env.NODE_ENV !== "production") {
      await firebase.auth().useEmulator(process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_URL ?? '');
    }

    // タブ間で認証状態を保持する為、認証の永続性を「LOCAL」にする。
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  })();
}

export const auth = firebase.auth();
